import React from 'react';
import { useAppSelector } from '../store/hooks';
import { selectIsRefreshingToken } from '../store/authSlice';
import './TokenRefreshIndicator.css';

/**
 * Ненавязчивый индикатор фонового обновления сессии (не блокирует страницу).
 */
const TokenRefreshIndicator: React.FC = () => {
  const isRefreshing = useAppSelector(selectIsRefreshingToken);

  if (!isRefreshing) return null;

  return (
    <div
      className="token-refresh-indicator"
      role="status"
      aria-live="polite"
      aria-label="Обновление сессии"
    >
      <span className="token-refresh-indicator__spinner" aria-hidden="true" />
      <span className="token-refresh-indicator__text">Обновление сессии…</span>
    </div>
  );
};

export default TokenRefreshIndicator;
